import React from 'react';
import { Alert, Button } from 'react-bootstrap';

const AlertBox = (props) => {
  const { show, setShow } = props;
  const { alertHeading, alertContent, variant } = props.alertProps;
  return (
    <>
      <div className='w-50 position-absolute top-50 start-50 translate-middle z-3'>
        <Alert show={show} variant={variant}>
          <Alert.Heading>{alertHeading}</Alert.Heading>
          <p>{alertContent}</p>
          <hr />
          <div className='d-flex justify-content-end'>
            <Button onClick={() => setShow(false)} variant='outline-success'>
              Close me
            </Button>
          </div>
        </Alert>
      </div>
    </>
  );
};

export default AlertBox;
























